import React from 'react'
import Reflux from 'reflux'
import _ from 'lodash'
import { Container, Row, Col, Button, Card, CardBody, CardHeader } from 'reactstrap'

import ShoppingListStore from '~/modules/shoppingList/listStore.js'
import ShoppingListActions from '~/modules/shoppingList/listActions.js'

import SelectCategory from '~/modules/shoppingList/selectCategory.jsx'
import SelectRecipe from '~/modules/shoppingList/selectRecipe.jsx'
import Quantities from '~/modules/shoppingList/quantities.jsx'
import List from '~/modules/shoppingList/list.jsx'


export default class ShoppingList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = ShoppingListStore
	}

	render() {
		const existingRecipes = _.map(this.state.shoppingList, 'recipeID')

		return (
			<Container>
				<Row>
					<Col sm={12}>
						<Card>
							<CardHeader>
								Select recipe(s)
							</CardHeader>
							<CardBody>
								<table>
									<tbody>
										<tr>
											<td>
												Category:<br />
												<SelectCategory
													onChange={ShoppingListActions.setCategoryID}
													value={this.state.categoryID}
												/>
											</td>
											<td>&nbsp;</td>
											<td>
												Recipe:<br />
												<SelectRecipe
													onChange={ShoppingListActions.setRecipeID}
													value={this.state.recipeID}
													categoryID={this.state.categoryID}
													existingRecipes={existingRecipes}
												/>
											</td>
											<td>&nbsp;</td>
											<td>
												<br />
												<Button
													onClick={ShoppingListActions.addRecipeToList}
													color="primary"
													disabled={this.state.recipeID === 0}
												>
													Add
												</Button>
											</td>
										</tr>
									</tbody>
								</table>
							</CardBody>
						</Card>

						{
							this.state.shoppingList.length > 0 &&

							<React.Fragment>
								<Card>
									<CardHeader>
										Set Quantities
									</CardHeader>
									<CardBody>
										<Quantities />
									</CardBody>
								</Card>

								<Card>
									<CardHeader>
										Your Shopping List
									</CardHeader>
									<CardBody>
										<List />
									</CardBody>
								</Card>
							</React.Fragment>
						}
					</Col>
				</Row>
			</Container>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/index.jsx